// extracted by mini-css-extract-plugin
export var container = "index-module--container--e6852";
export var footer = "index-module--footer--8aefb";
export var footerEmail = "index-module--footer-email--5a99a";
export var footerRights = "index-module--footer-rights--c6d54";